import { h } from './index-5faac9d7.js';

const PesProductLink = ({ url, id, className, enableAppRouting, tabId, saveInIndexDB }, children) => {
  let props = {
    page: 'product',
    pageId: id,
    className,
    tabId,
    saveInIndexDB,
  };
  if (!enableAppRouting) {
    props = Object.assign(Object.assign({}, props), { url });
  }
  return h("pes-router-link", Object.assign({}, props), children);
};

export { PesProductLink as P };
